// extracted by mini-css-extract-plugin
export default {"container":"zero_decision_lib-module__container--ye9Hu","main":"zero_decision_lib-module__main--3xnHT","title":"zero_decision_lib-module__title--3Ps79"};